import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6f83db0c = () => interopDefault(import('..\\pages\\blocked.vue' /* webpackChunkName: "pages/blocked" */))
const _4e9fa3d9 = () => interopDefault(import('..\\pages\\dev-help\\index.vue' /* webpackChunkName: "pages/dev-help/index" */))
const _33316409 = () => interopDefault(import('..\\pages\\login.vue' /* webpackChunkName: "pages/login" */))
const _ffe7b4cc = () => interopDefault(import('..\\pages\\logout.vue' /* webpackChunkName: "pages/logout" */))
const _9a0a59de = () => interopDefault(import('..\\pages\\backoffice\\authorization-error\\index.vue' /* webpackChunkName: "pages/backoffice/authorization-error/index" */))
const _4838ea0c = () => interopDefault(import('..\\pages\\backoffice\\catalog\\index.vue' /* webpackChunkName: "pages/backoffice/catalog/index" */))
const _10c86e62 = () => interopDefault(import('..\\pages\\backoffice\\configuration\\index.vue' /* webpackChunkName: "pages/backoffice/configuration/index" */))
const _2299c9f1 = () => interopDefault(import('..\\pages\\backoffice\\dashboard\\index.vue' /* webpackChunkName: "pages/backoffice/dashboard/index" */))
const _78a24873 = () => interopDefault(import('..\\pages\\backoffice\\media-library\\index.vue' /* webpackChunkName: "pages/backoffice/media-library/index" */))
const _45f104a7 = () => interopDefault(import('..\\pages\\backoffice\\my-profile\\index.vue' /* webpackChunkName: "pages/backoffice/my-profile/index" */))
const _15ce36ac = () => interopDefault(import('..\\pages\\backoffice\\product-catalog\\index.vue' /* webpackChunkName: "pages/backoffice/product-catalog/index" */))
const _f938be70 = () => interopDefault(import('..\\pages\\backoffice\\seo\\index.vue' /* webpackChunkName: "pages/backoffice/seo/index" */))
const _203b7400 = () => interopDefault(import('..\\pages\\backoffice\\shopping-cart\\index.vue' /* webpackChunkName: "pages/backoffice/shopping-cart/index" */))
const _49ec1aec = () => interopDefault(import('..\\pages\\backoffice\\wishlist\\index.vue' /* webpackChunkName: "pages/backoffice/wishlist/index" */))
const _1969a5f4 = () => interopDefault(import('..\\pages\\backoffice\\cms\\components\\index.vue' /* webpackChunkName: "pages/backoffice/cms/components/index" */))
const _603bff02 = () => interopDefault(import('..\\pages\\backoffice\\cms\\contents\\index.vue' /* webpackChunkName: "pages/backoffice/cms/contents/index" */))
const _15b1e651 = () => interopDefault(import('..\\pages\\backoffice\\financial\\customer-credits\\index.vue' /* webpackChunkName: "pages/backoffice/financial/customer-credits/index" */))
const _91aaa794 = () => interopDefault(import('..\\pages\\backoffice\\financial\\invoices\\index.vue' /* webpackChunkName: "pages/backoffice/financial/invoices/index" */))
const _5de7c4e2 = () => interopDefault(import('..\\pages\\backoffice\\financial\\payments\\index.vue' /* webpackChunkName: "pages/backoffice/financial/payments/index" */))
const _b82bebee = () => interopDefault(import('..\\pages\\backoffice\\order-creation\\estimate\\index.vue' /* webpackChunkName: "pages/backoffice/order-creation/estimate/index" */))
const _6bb7ce5d = () => interopDefault(import('..\\pages\\backoffice\\status-tracking\\consignments\\index.vue' /* webpackChunkName: "pages/backoffice/status-tracking/consignments/index" */))
const _58313784 = () => interopDefault(import('..\\pages\\backoffice\\status-tracking\\job-orders\\index.vue' /* webpackChunkName: "pages/backoffice/status-tracking/job-orders/index" */))
const _288e1cfc = () => interopDefault(import('..\\pages\\backoffice\\status-tracking\\quotes\\index.vue' /* webpackChunkName: "pages/backoffice/status-tracking/quotes/index" */))
const _003474e6 = () => interopDefault(import('..\\pages\\backoffice\\status-tracking\\sales-orders\\index.vue' /* webpackChunkName: "pages/backoffice/status-tracking/sales-orders/index" */))
const _c2f3fd8e = () => interopDefault(import('..\\pages\\backoffice\\order-creation\\custom-order\\item-type\\_id\\index.vue' /* webpackChunkName: "pages/backoffice/order-creation/custom-order/item-type/_id/index" */))
const _1e57b535 = () => interopDefault(import('..\\pages\\backoffice\\cms\\components\\_componentId.vue' /* webpackChunkName: "pages/backoffice/cms/components/_componentId" */))
const _c4b61f16 = () => interopDefault(import('..\\pages\\backoffice\\cms\\contents\\_contentId.vue' /* webpackChunkName: "pages/backoffice/cms/contents/_contentId" */))
const _1cc30cb2 = () => interopDefault(import('..\\pages\\backoffice\\order-creation\\custom-order\\_id.vue' /* webpackChunkName: "pages/backoffice/order-creation/custom-order/_id" */))
const _01a81e61 = () => interopDefault(import('..\\pages\\backoffice\\product-catalog\\_productCategoryId.vue' /* webpackChunkName: "pages/backoffice/product-catalog/_productCategoryId" */))
const _739c6938 = () => interopDefault(import('..\\pages\\backoffice\\product\\_id\\index.vue' /* webpackChunkName: "pages/backoffice/product/_id/index" */))
const _5303fa2a = () => interopDefault(import('..\\pages\\backoffice\\catalog\\_id\\products\\index.vue' /* webpackChunkName: "pages/backoffice/catalog/_id/products/index" */))
const _6ccbee9a = () => interopDefault(import('..\\pages\\backoffice\\catalog\\_id\\products\\_masterItemTypeId\\variants\\index.vue' /* webpackChunkName: "pages/backoffice/catalog/_id/products/_masterItemTypeId/variants/index" */))
const _70f28dff = () => interopDefault(import('..\\pages\\_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/blocked",
    component: _6f83db0c,
    name: "blocked___en"
  }, {
    path: "/dev-help",
    component: _4e9fa3d9,
    name: "dev-help___en"
  }, {
    path: "/login",
    component: _33316409,
    name: "login___en"
  }, {
    path: "/logout",
    component: _ffe7b4cc,
    name: "logout___en"
  }, {
    path: "/backoffice/authorization-error",
    component: _9a0a59de,
    name: "backoffice-authorization-error___en"
  }, {
    path: "/backoffice/catalog",
    component: _4838ea0c,
    name: "backoffice-catalog___en"
  }, {
    path: "/backoffice/configuration",
    component: _10c86e62,
    name: "backoffice-configuration___en"
  }, {
    path: "/backoffice/dashboard",
    component: _2299c9f1,
    name: "backoffice-dashboard___en"
  }, {
    path: "/backoffice/media-library",
    component: _78a24873,
    name: "backoffice-media-library___en"
  }, {
    path: "/backoffice/my-profile",
    component: _45f104a7,
    name: "backoffice-my-profile___en"
  }, {
    path: "/backoffice/product-catalog",
    component: _15ce36ac,
    name: "backoffice-product-catalog___en"
  }, {
    path: "/backoffice/seo",
    component: _f938be70,
    name: "backoffice-seo___en"
  }, {
    path: "/backoffice/shopping-cart",
    component: _203b7400,
    name: "backoffice-shopping-cart___en"
  }, {
    path: "/backoffice/wishlist",
    component: _49ec1aec,
    name: "backoffice-wishlist___en"
  }, {
    path: "/fr/blocked",
    component: _6f83db0c,
    name: "blocked___fr"
  }, {
    path: "/fr/dev-help",
    component: _4e9fa3d9,
    name: "dev-help___fr"
  }, {
    path: "/fr/login",
    component: _33316409,
    name: "login___fr"
  }, {
    path: "/fr/logout",
    component: _ffe7b4cc,
    name: "logout___fr"
  }, {
    path: "/backoffice/cms/components",
    component: _1969a5f4,
    name: "backoffice-cms-components___en"
  }, {
    path: "/backoffice/cms/contents",
    component: _603bff02,
    name: "backoffice-cms-contents___en"
  }, {
    path: "/backoffice/financial/customer-credits",
    component: _15b1e651,
    name: "backoffice-financial-customer-credits___en"
  }, {
    path: "/backoffice/financial/invoices",
    component: _91aaa794,
    name: "backoffice-financial-invoices___en"
  }, {
    path: "/backoffice/financial/payments",
    component: _5de7c4e2,
    name: "backoffice-financial-payments___en"
  }, {
    path: "/backoffice/order-creation/estimate",
    component: _b82bebee,
    name: "backoffice-order-creation-estimate___en"
  }, {
    path: "/backoffice/status-tracking/consignments",
    component: _6bb7ce5d,
    name: "backoffice-status-tracking-consignments___en"
  }, {
    path: "/backoffice/status-tracking/job-orders",
    component: _58313784,
    name: "backoffice-status-tracking-job-orders___en"
  }, {
    path: "/backoffice/status-tracking/quotes",
    component: _288e1cfc,
    name: "backoffice-status-tracking-quotes___en"
  }, {
    path: "/backoffice/status-tracking/sales-orders",
    component: _003474e6,
    name: "backoffice-status-tracking-sales-orders___en"
  }, {
    path: "/fr/backoffice/authorization-error",
    component: _9a0a59de,
    name: "backoffice-authorization-error___fr"
  }, {
    path: "/fr/backoffice/catalog",
    component: _4838ea0c,
    name: "backoffice-catalog___fr"
  }, {
    path: "/fr/backoffice/configuration",
    component: _10c86e62,
    name: "backoffice-configuration___fr"
  }, {
    path: "/fr/backoffice/dashboard",
    component: _2299c9f1,
    name: "backoffice-dashboard___fr"
  }, {
    path: "/fr/backoffice/media-library",
    component: _78a24873,
    name: "backoffice-media-library___fr"
  }, {
    path: "/fr/backoffice/my-profile",
    component: _45f104a7,
    name: "backoffice-my-profile___fr"
  }, {
    path: "/fr/backoffice/product-catalog",
    component: _15ce36ac,
    name: "backoffice-product-catalog___fr"
  }, {
    path: "/fr/backoffice/seo",
    component: _f938be70,
    name: "backoffice-seo___fr"
  }, {
    path: "/fr/backoffice/shopping-cart",
    component: _203b7400,
    name: "backoffice-shopping-cart___fr"
  }, {
    path: "/fr/backoffice/wishlist",
    component: _49ec1aec,
    name: "backoffice-wishlist___fr"
  }, {
    path: "/fr/backoffice/cms/components",
    component: _1969a5f4,
    name: "backoffice-cms-components___fr"
  }, {
    path: "/fr/backoffice/cms/contents",
    component: _603bff02,
    name: "backoffice-cms-contents___fr"
  }, {
    path: "/fr/backoffice/financial/customer-credits",
    component: _15b1e651,
    name: "backoffice-financial-customer-credits___fr"
  }, {
    path: "/fr/backoffice/financial/invoices",
    component: _91aaa794,
    name: "backoffice-financial-invoices___fr"
  }, {
    path: "/fr/backoffice/financial/payments",
    component: _5de7c4e2,
    name: "backoffice-financial-payments___fr"
  }, {
    path: "/fr/backoffice/order-creation/estimate",
    component: _b82bebee,
    name: "backoffice-order-creation-estimate___fr"
  }, {
    path: "/fr/backoffice/status-tracking/consignments",
    component: _6bb7ce5d,
    name: "backoffice-status-tracking-consignments___fr"
  }, {
    path: "/fr/backoffice/status-tracking/job-orders",
    component: _58313784,
    name: "backoffice-status-tracking-job-orders___fr"
  }, {
    path: "/fr/backoffice/status-tracking/quotes",
    component: _288e1cfc,
    name: "backoffice-status-tracking-quotes___fr"
  }, {
    path: "/fr/backoffice/status-tracking/sales-orders",
    component: _003474e6,
    name: "backoffice-status-tracking-sales-orders___fr"
  }, {
    path: "/fr/backoffice/order-creation/custom-order/item-type/:id",
    component: _c2f3fd8e,
    name: "backoffice-order-creation-custom-order-item-type-id___fr"
  }, {
    path: "/backoffice/order-creation/custom-order/item-type/:id",
    component: _c2f3fd8e,
    name: "backoffice-order-creation-custom-order-item-type-id___en"
  }, {
    path: "/fr/backoffice/cms/components/:componentId",
    component: _1e57b535,
    name: "backoffice-cms-components-componentId___fr"
  }, {
    path: "/fr/backoffice/cms/contents/:contentId",
    component: _c4b61f16,
    name: "backoffice-cms-contents-contentId___fr"
  }, {
    path: "/fr/backoffice/order-creation/custom-order/:id?",
    component: _1cc30cb2,
    name: "backoffice-order-creation-custom-order-id___fr"
  }, {
    path: "/backoffice/cms/components/:componentId",
    component: _1e57b535,
    name: "backoffice-cms-components-componentId___en"
  }, {
    path: "/backoffice/cms/contents/:contentId",
    component: _c4b61f16,
    name: "backoffice-cms-contents-contentId___en"
  }, {
    path: "/backoffice/order-creation/custom-order/:id?",
    component: _1cc30cb2,
    name: "backoffice-order-creation-custom-order-id___en"
  }, {
    path: "/fr/backoffice/product-catalog/:productCategoryId?",
    component: _01a81e61,
    name: "backoffice-product-catalog-productCategoryId___fr"
  }, {
    path: "/fr/backoffice/product/:id",
    component: _739c6938,
    name: "backoffice-product-id___fr"
  }, {
    path: "/fr/backoffice/catalog/:id/products",
    component: _5303fa2a,
    name: "backoffice-catalog-id-products___fr"
  }, {
    path: "/fr/backoffice/catalog/:id/products/:masterItemTypeId/variants",
    component: _6ccbee9a,
    name: "backoffice-catalog-id-products-masterItemTypeId-variants___fr"
  }, {
    path: "/backoffice/product-catalog/:productCategoryId?",
    component: _01a81e61,
    name: "backoffice-product-catalog-productCategoryId___en"
  }, {
    path: "/backoffice/product/:id",
    component: _739c6938,
    name: "backoffice-product-id___en"
  }, {
    path: "/backoffice/catalog/:id/products",
    component: _5303fa2a,
    name: "backoffice-catalog-id-products___en"
  }, {
    path: "/backoffice/catalog/:id/products/:masterItemTypeId/variants",
    component: _6ccbee9a,
    name: "backoffice-catalog-id-products-masterItemTypeId-variants___en"
  }, {
    path: "/fr/*",
    component: _70f28dff,
    name: "all___fr"
  }, {
    path: "/*",
    component: _70f28dff,
    name: "all___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config.app && config.app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
